export default {
  small: 576,
  medium: 752,
  large: 1024,
  xlarge: 1152,
};
